import crypto from "node:crypto";
import mnsvc2 from "./mnsvc2";

const encode_mnsv2 = require("./x_s.encoder.js") as (
    mnsv2: string,
    type: string,
    platform: string,
    req_type: string,
) => string;

export class Xhshow {
    private stringifyCookies(cookies: Record<string, any>): string {
        return Object.entries(cookies)
            .map(([key, value]) => `${key}=${value}`)
            .join("; ");
    }
    // constructor() {

    // console.log("Xhshow xs encoder initialized");
    // }

    signHeadersGet(
        uri: string,
        cookieString: Record<string, any>,
        xsecAppid = "ugc",
        params?: Record<string, unknown> | null,
    ): Record<string, string> {
        let para1 = "";
        if (!params || Object.keys(params).length === 0) {
            para1 = uri;
        } else {
            const _queryPara = Object.entries(params).map(([key, value]) => {
                let valueStr = "";
                if (Array.isArray(value)) {
                    valueStr = value.map((v) => String(v)).join(",");
                } else if (value !== null && value !== undefined) {
                    valueStr = String(value);
                }
                return `${key}=${valueStr}`;
            });
            para1 = `${uri}?${_queryPara.join("&")}`;
        }

        const md5Para1 = crypto.createHash("md5").update(para1).digest("hex"); // md5 enc
        const mnsvc2_data = mnsvc2(para1, md5Para1, this.stringifyCookies(cookieString));

        return { "X-S": encode_mnsv2(mnsvc2_data, xsecAppid, "Windows", "object") };
    }

    signHeadersPost(
        uri: string,
        cookieString: Record<string, any>,
        xsecAppid = "ugc",
        payload?: Record<string, unknown> | null,
    ): Record<string, string> {
        const para1 = uri + JSON.stringify(payload || {});
        const md5Para1 = crypto.createHash("md5").update(para1).digest("hex"); // md5 enc
        const mnsvc2_data = mnsvc2(para1, md5Para1, this.stringifyCookies(cookieString));

        return { "X-S": encode_mnsv2(mnsvc2_data, xsecAppid, "Windows", "object") };
    }
}

export default Xhshow;
//
// const xhshow = new Xhshow();
//
// // For test
// console.log(
//     xhshow.signXsPost(
//         "/api/sns/web/v1/feed",
//         "19aa5490309ue3bza2poh9lwqsqw2og6azztnku2050000809471",
//         "xhs-pc-web",
//         {"source_note_id":"6909f57e0000000007015f28","image_formats":["jpg","webp","avif"],"extra":{"need_body_topic":"1"},"xsec_source":"pc_search","xsec_token":"ABEFyvlKvV2nK8QceNjsokHdjsoo7gonz4YIlxkzRbb5w="}
//     )
// );

// console.log(xhshow.signXsGet("/api/sns/web/v1/search/filter", "19aa5490309ue3bza2poh9lwqsqw2og6azztnku2050000809471", "xhs-pc-web", {keyword:"ios26.1正式版", search_id:"2fn6umax1wg3kk0igh956"}));
